import * as React from 'react';
import OrderDetailsError from '../order-details-new/components/order-details-error';
import OrderLoading from './components/order-details-loading';
import Surface from '@able/react/dist/Surface';
import useProductOrderDataFetch from './hooks/use-product-order-data-fetch';
import OrderDetailsBreadcrumbs from './components/order-details-breadcrumb';
import OrderDetailsContainer from './components/order-details-container';
import './style.less';

const OrderDetailsNew = () => {
  const {
    orderNumber,
    cidn,
    isSuccess,
    isError,
    isLoading,
    isMpexOrder,
    isStaffUser,
  } = useProductOrderDataFetch();

  return (
    <Surface
      className="order-details-container"
      background={
        isSuccess && !isMpexOrder
          ? 'materialBaseSecondary'
          : 'materialBasePrimary'
      }
      cornerRadius="cornerRadiusNone"
      interactive={false}
      variant="SurfaceFlat"
    >
      {isSuccess ? (
        <React.Fragment>
          <OrderDetailsBreadcrumbs />
          <OrderDetailsContainer
            orderNumber={orderNumber}
            cidn={cidn}
            isMpexOrder={isMpexOrder}
            isStaffUser={isStaffUser}
          />
        </React.Fragment>
      ) : isLoading ? (
        <OrderLoading />
      ) : isError ? (
        <React.Fragment>
          <OrderDetailsBreadcrumbs />
          <OrderDetailsError />
        </React.Fragment>
      ) : (
        <React.Fragment />
      )}
    </Surface>
  );
};

export default OrderDetailsNew;
